import React from "react";
import Footer from "../../../components/Footer/Footer";
import {
  Brand,
  Content,
  Header,
  HeroHeadline,
  List,
  PageWrapper,
  Paragraph,
  Section,
  SectionHeading,
  Strong,
  UpdatedDate,
} from "../Policy/styled";

const DesktopTerms: React.FC = () => {
  const effectiveDate = "February 10, 2025";

  return (
    <PageWrapper>
      <Header>
        <Brand>Cabinet Logger</Brand>
        <HeroHeadline>Terms of Use</HeroHeadline>
        <UpdatedDate>Effective {effectiveDate}</UpdatedDate>
        <Paragraph>
          These Terms govern access to Cabinet Scanner, operated by Blunt
          Solutions, LLC. By installing or using the app you agree to the
          obligations below as a representative of your organization.
        </Paragraph>
      </Header>

      <Content>
        <Section>
          <SectionHeading>Account Eligibility</SectionHeading>
          <Paragraph>
            Cabinet Scanner is provided to cabinet manufacturers, dealers, and
            their logistics partners under written onboarding agreements.
            Accounts are provisioned after verification of company ownership and
            role. You are responsible for maintaining accurate user rosters and
            promptly disabling access for teammates who leave your organization.
          </Paragraph>
        </Section>

        <Section>
          <SectionHeading>Acceptable Use</SectionHeading>
          <List>
            <li>
              <Strong>Confidential data</Strong> entered into the platform must
              relate to your organization’s shipments. Do not upload unlawful,
              infringing, or deceptive content.
            </li>
            <li>
              <Strong>Security obligations</Strong> include keeping credentials
              private, using only company-managed devices for scanning, and
              notifying us immediately if you suspect unauthorized access.
            </li>
            <li>
              <Strong>Service integrity</Strong> prohibits reverse engineering,
              automated scraping, or attempting to bypass rate limits or access
              controls.
            </li>
          </List>
        </Section>

        <Section>
          <SectionHeading>Subscription &amp; Billing</SectionHeading>
          <Paragraph>
            Access requires an active subscription billed to the contracting
            manufacturer or dealer through the channels outlined during
            onboarding. Fees are non-refundable except where required by law or
            explicitly stated in your order form. Failure to keep the account in
            good standing may result in suspension.
          </Paragraph>
        </Section>

        <Section>
          <SectionHeading>Data Rights</SectionHeading>
          <Paragraph>
            You retain ownership of shipment data you submit. You grant Cabinet
            Logger a license to process that data to provide the service, comply
            with law, and improve the platform. Please review the Privacy Policy
            for details on how we collect and safeguard information.
          </Paragraph>
        </Section>

        <Section>
          <SectionHeading>Termination</SectionHeading>
          <Paragraph>
            You may terminate the service by following the in-app “Delete
            Account” workflow or contacting support. We may suspend or end
            access for violations of these Terms, non-payment, or legal
            requirements. Upon termination we remove user credentials while
            retaining shipment logs we are obligated to preserve.
          </Paragraph>
        </Section>

        <Section>
          <SectionHeading>Disclaimer &amp; Liability</SectionHeading>
          <Paragraph>
            Cabinet Scanner is provided “as is.” To the fullest extent permitted
            by law we disclaim implied warranties and limit liability to amounts
            paid for the service during the twelve months preceding the claim.
            Neither party is liable for indirect or consequential damages.
          </Paragraph>
        </Section>

        <Section>
          <SectionHeading>Contact</SectionHeading>
          <Paragraph>
            Questions about these Terms can be sent to
            support@cabinetlogger.com or to the mailing address listed in the
            Privacy Policy.
          </Paragraph>
        </Section>
      </Content>

      <Footer />
    </PageWrapper>
  );
};

export default DesktopTerms;
